import { Icons as e } from "../Icons/Icons.mjs";
import { IconButton as t } from "./IconButton.mjs";
import n from "react";
import { useTranslation as r } from "@maat/store-i18n";
import { jsx as i } from "react/jsx-runtime";
import { useCopyToClipboard as a } from "@maat/hooks";
//#region src/components/Button/CopyButton.tsx
var o = n.forwardRef(({ value: n, iconSize: o = 16, onCopied: s, label: c, tooltip: l, ...u }, d) => {
	let { copy: f, copied: p } = a(), { t: m } = r("ds");
	return /* @__PURE__ */ i(t, {
		ref: d,
		icon: i(p ? e.Check : e.Copy, { size: o }),
		label: p ? m("ds:copyButton.copied") : c ?? m("ds:copyButton.copy"),
		tooltip: l ?? m(p ? "ds:copyButton.copied" : "ds:copyButton.copy"),
		onClick: async () => {
			await f(n) && s?.();
		},
		...u
	});
});
o.displayName = "CopyButton";
//#endregion
export { o as CopyButton };
